export const AdminUsersSkeleton = () => (
  <div className="admin-users-page admin-skeleton" aria-hidden="true">
    <div className="admin-heading admin-users-heading">
      <div className="admin-users-heading-copy skeleton-stack">
        <span className="skeleton short" />
        <span className="skeleton title" />
        <span className="skeleton text" />
      </div>
    </div>

    <div className="admin-users-layout">
      <section className="admin-users-main skeleton-stack">
        <span className="skeleton admin-users-search-skeleton" />
        {Array.from({ length: 3 }).map((_, index) => (
          <article className="admin-user-card admin-user-card--skeleton" key={index}>
            <span className="skeleton title" />
            <span className="skeleton text" />
            <span className="skeleton text short" />
          </article>
        ))}
      </section>

      <aside className="admin-users-create-panel skeleton-stack">
        <span className="skeleton title" />
        <span className="skeleton text" />
        <span className="skeleton text" />
        <span className="skeleton text short" />
      </aside>
    </div>
  </div>
);
